/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilterPatientDto } from '../../models/filter-patient-dto';
import { ResponsePatientDto } from '../../models/response-patient-dto';

export interface PatientsControllerFilter$Params {
  
    /**
     * The filtering criteria
     */
    body: FilterPatientDto
}

export function patientsControllerFilter(http: HttpClient, rootUrl: string, params: PatientsControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponsePatientDto>>> {
  const rb = new RequestBuilder(rootUrl, patientsControllerFilter.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResponsePatientDto>>;
    })
  );
}

patientsControllerFilter.PATH = '/thalea-patients/patients/filter';
